import Vue from 'vue';
import EmailDigestModal from 'components/widgets/EmailDigest/EmailDigestModal.vue';
import { BfModal, BfDialog, BfButton, BfSpinner } from 'src/components/Butterfly';
import ProjectAPI from 'src/api/project';
import * as cronstrue from 'cronstrue';
const EmailDigestManagementModal = Vue.extend({
    components: {
        BfModal,
        BfDialog,
        BfButton,
        BfSpinner,
        EmailDigestModal,
    },
    props: {
        visible: { type: Boolean, default: false, required: false },
        dashboard: { type: Object, required: true },
        sortedSegmentsForFieldsLimited: { type: Object, required: true },
        currentAnalysis: { type: Object, required: true },
        savedQueries: { type: Array, required: true },
        hasNps: { type: Boolean, default: false, required: false },
        hasSentiment: { type: Boolean, default: false, required: false },
    },
    data() {
        return {
            loading: true,
            digests: [],
            digestToDelete: null,
            digestToEdit: null,
            editModalVisible: false,
        };
    },
    watch: {
        visible(newValue) {
            if (newValue) {
                this.fetchDigests();
            }
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async fetchDigests() {
            this.loading = true;
            const { data } = await ProjectAPI.listEmailDigests(this.dashboard.id);
            this.digests = data;
            this.loading = false;
        },
        async deleteDigest(id) {
            this.$analytics.track.dashboard.digest.deleted(id, this.dashboard.id);
            await ProjectAPI.deleteEmailDigest(this.dashboard.id, id);
            this.digestToDelete = null;
            this.fetchDigests();
        },
        getCronString(cron) {
            try {
                return cronstrue.toString(cron);
            }
            catch (e) {
                console.error(e);
                return 'err';
            }
        },
        editDigest(digest) {
            this.digestToEdit = digest;
            this.editModalVisible = true;
        },
        closeEditModal() {
            this.digestToEdit = null;
            this.editModalVisible = false;
        },
    }
});
export default EmailDigestManagementModal;
